module.exports = __webpack_public_path__ + "static/media/argos.f29fe6d3.svg";